import {FC, useState} from 'react';
import {useRecoilState, useRecoilValue} from 'recoil';

import {Box, Drawer} from '@mui/material';
import {EditDevice} from './EditDevice';
import Fallback from '../../../../ui/fallback/Fallback';

import {currentDeviceState, deviceControlModeState, deviceControlState} from '../../../../store/deviceModels/atoms';

const DeviceControl: FC = () => {
  const mode = useRecoilValue(deviceControlModeState);
  const device = useRecoilValue(currentDeviceState);
  const [open, setOpen] = useRecoilState(deviceControlState);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    !loading && setOpen(false);
  };

  return (
    <Drawer open={open} onClose={handleClose} anchor="right">
      <Box sx={{width: '662px', p: 3}} role="presentation">
        {mode === 'EDIT' && device ? (
          <EditDevice device={device} loading={loading} setLoading={setLoading} handleClose={handleClose} />
        ) : (
          <Fallback />
        )}
      </Box>
    </Drawer>
  );
};

export default DeviceControl;
